












import VimeoPlayerComponent from './VimeoPlayerComponent.vue';
import YoutubePlayerComponent from './YoutubePlayerComponent.vue';

import ConsentService from '@/shared/services/consent-service';
import {defineComponent, onMounted} from "@vue/composition-api";
import {useMutations, useState} from "vuex-composition-helpers";

export default defineComponent({
  name: 'VideoPlayerWidget',
  components: {
    VimeoPlayerComponent,
    YoutubePlayerComponent
  },
  props: {
    id: {type: String, required: true},
    playerType: {type: [Number, String]},
    consentHtml: {type: String}
  },
  setup: () => {
    const {minCookieLevel, disabled} = useState(['minCookieLevel', 'disabled'])
    const {setDisabled} = useMutations(['setDisabled'])

    function checkCookieConsent(min: number): boolean {
      return ConsentService.validate(min);
    }

    function recheckAllowedToViewVideo() {
      setDisabled(!allowedToViewVideo())
    }

    function allowedToViewVideo(): boolean {
      return checkCookieConsent(minCookieLevel.value);
    }

    onMounted(() => {
      recheckAllowedToViewVideo();
      window.dispatchEvent(new Event('initializeConsentLinks'));
      window.addEventListener('consentLevelUpdate', function () {
        recheckAllowedToViewVideo();
      });
    })

    return {
      disabled
    }
  }
})
